import React from "react";
import Rating from "@material-ui/lab/Rating";
import TextField from "@material-ui/core/TextField";
import { customIcons, IconContainer } from "../../Branches/ReviewDrawerContent";
import { useSelector } from "react-redux";
import MuiPhoneNumber from "material-ui-phone-number";

const OrderFeedbackSection = ({
  orderComment,
  orderReviewStars,
  customerName,
  customerPhone,
  commentError,
  handleChangeName,
  handleChangePhone,
  phoneFieldKey,
  handleCommentChange,
  handleOrderReviewStars,
}) => {
  const language = useSelector((state) => state.store.language);
  const countries = useSelector(
    (state) => state.store.store.all_countries || state.store.store.countries
  );
  const address = useSelector((state) => state.customers?.address);
  const store = useSelector((state) => state.store.store);
  const settings = useSelector((state) => state.store.store.settings);
  const countryObj = countries?.find((c) => c?.id === address?.country);
  return (
    <div
      style={{
        paddingTop: 20,
        paddingBottom: 20,
      }}
    >
      <Rating
        name="simple-controlled"
        value={orderReviewStars}
        onChange={(event, newValue) => {
          handleOrderReviewStars(event, newValue);
        }}
        classes={{ label: "large-star" }}
        style={{ marginTop: 10, marginBottom: 10 }}
        IconContainerComponent={IconContainer}
        getLabelText={(value) => customIcons[value].label}
      />
      <div
        className="row mx-auto"
        dir={language == "english" ? "ltr" : "rtl"}
        style={{ width: "92%", marginBottom: 20, marginTop: 10 }}
      >
        <div
          className={"col-6 ".concat(language == "english" ? "pl-0" : "pr-0")}
          style={{
            paddingRight: 10,
          }}
        >
          <h4
            className={language == "english" ? "text-left" : "text-right"}
            dir={language == "english" ? "ltr" : "rtl"}
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              marginTop: 10,
              marginBottom: 3,
            }}
          >
            {language == "english" ? "Name" : "الاسم"}{" "}
            <span style={{ color: "grey", fontSize: 10 }}>
              ({language == "english" ? "Optional" : "اختياري"})
            </span>
          </h4>
          <TextField
            dir={language == "english" ? "ltr" : "rtl"}
            style={{ width: "100%", marginBottom: 0 }}
            id="outlined-textarea"
            variant="outlined"
            value={customerName}
            onChange={handleChangeName}
          />
        </div>
        <div
          className={"col-6 ".concat(language == "english" ? "pr-0" : "pl-0")}
          style={{
            paddingLeft: 5,
          }}
        >
          <h4
            className={language == "english" ? "text-left" : "text-right"}
            dir={language == "english" ? "ltr" : "rtl"}
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              marginTop: 10,
              marginBottom: 3,
            }}
          >
            {language == "english" ? "Phone" : "رقم الهاتف"}{" "}
            <span style={{ color: "grey", fontSize: 10 }}>
              ({language == "english" ? "Optional" : "اختياري"})
            </span>
          </h4>

          <MuiPhoneNumber
            variant="outlined"
            defaultCountry={
              countryObj?.dial_code || store.default_dial_code || "kw"
            }
            onlyCountries={
              settings.show_all_country_codes
                ? []
                : [
                    "kw",
                    "sa",
                    "qa",
                    "om",
                    "ae",
                    "bh",
                    "sy",
                    "lb",
                    "jo",
                    "eg",
                    "us",
                    "uk",
                    "cn",
                  ]
            }
            excludeCountries={["il"]}
            countryCodeEditable={false}
            disableAreaCodes={true}
            onChange={handleChangePhone}
            key={phoneFieldKey}
            value={customerPhone}
            fullWidth
            FormHelperTextProps={{
              style: {
                textAlign: language == "arabic" && "right",
                marginRight: language == "arabic" && 5,
              },
            }}
          />
        </div>
      </div>
      <div
        className="row mx-auto"
        dir={language == "english" ? "ltr" : "rtl"}
        style={{ width: "92%" }}
      >
        <h4
          className={language == "english" ? "text-left" : "text-right"}
          dir={language == "english" ? "ltr" : "rtl"}
          style={{
            fontFamily: language == "english" ? "Quicksand" : "Cairo",
            marginTop: 10,
            marginBottom: 3,
          }}
        >
          {language == "english" ? "Leave us a comment" : "اترك لنا تعليق"}{" "}
          {commentError && (
            <span style={{ color: "red" }}>
              {" "}
              {language == "english"
                ? "- Please enter a comment"
                : "- الرجاء كتابة تعليق"}
            </span>
          )}
        </h4>
        <TextField
          dir={language == "english" ? "ltr" : "rtl"}
          style={{ width: "100%", marginBottom: 10 }}
          id="outlined-textarea"
          multiline
          value={orderComment}
          variant="outlined"
          error={commentError}
          onChange={handleCommentChange}
        />
      </div>
    </div>
  );
};

export default OrderFeedbackSection;
